'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'projectMaintenance', 'projectMaintenances',
    function ($scope, $modalInstance, projectMaintenance, projectMaintenances) {

        $scope.setProjectMaintenance = setProjectMaintenance;
        $scope.ok = ok;
        $scope.cancel = cancel;

        // инициализация
        init();

        // region Function

        function init() {
            $scope.projectMaintenance = angular.copy(projectMaintenance);
            $scope.projectMaintenances = angular.copy(projectMaintenances);
        }

        function setProjectMaintenance(projectMaintenance) {
            $scope.projectMaintenance = projectMaintenance;
        }

        function ok(item) {
            $modalInstance.close(item);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        // endregion

    }];